import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../nest-api";
import { Observable } from "rxjs";
import { RequestListingPerformance, ResponseListingPerformance } from "../dto/performance-planning.dto";

@Injectable()
export class PerformancePlanningApi {

  private service: string = '';
  private model: string = 'sf6s/performancePlanning';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public listing(payload: RequestListingPerformance, page: string | number, limit: string | number): Observable<ResponseListingPerformance> {
    const method: string = 'POST';
    const func: string = 'listing';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof page !== 'undefined' && page !== null) urlParams.page = page;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseListingPerformance>(method, url, params, urlParams, body, contentType, (10 * 60) * 1000);
  }

  public history(requestNo: string, periodCode: string, empId: string, referenceDate: Date, formNo: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'history';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;
    if (typeof periodCode !== 'undefined' && periodCode !== null) urlParams.periodCode = periodCode;
    if (typeof referenceDate !== 'undefined' && referenceDate !== null) urlParams.referenceDate = referenceDate;
    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;
    if (typeof formNo !== 'undefined' && formNo !== null) urlParams.formNo = formNo;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, null, 100000);
  }

  public revisionHistory(formNo: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'revisionHistory';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof formNo !== 'undefined' && formNo !== null) urlParams.formNo = formNo;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public empData(periodCode: string, empId: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'empData';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof periodCode !== 'undefined' && periodCode !== null) urlParams.periodCode = periodCode;
    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public libraryKPI(textSearch: string, limit: number, skip: number, kpiCode: any): Observable<any> {
    const method: string = 'GET';
    const func: string = 'libraryKPI';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof textSearch !== 'undefined' && textSearch !== null) urlParams.textSearch = textSearch;
    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof skip !== 'undefined' && skip !== null) urlParams.skip = skip;
    if (typeof kpiCode !== 'undefined' && kpiCode !== null) urlParams.kpiCode = kpiCode;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  add(formData): Observable<any> {
    const method: string = "POST";
    const func: string = "add";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  saveRevision(formData): Observable<any> {
    const method: string = "POST";
    const func: string = "saveRevision";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public checkKPICode(kpiCode: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'checkKPICode';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof kpiCode !== 'undefined' && kpiCode !== null) urlParams.kpiCode = kpiCode;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public revisionDetail(requestNo: string, periodCode: string, empId: string, formNo: string, reviewerEmpid: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'revisionDetail';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;
    if (typeof periodCode !== 'undefined' && periodCode !== null) urlParams.periodCode = periodCode;
    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;
    if (typeof formNo !== 'undefined' && formNo !== null) urlParams.formNo = formNo;
    if (typeof reviewerEmpid !== 'undefined' && reviewerEmpid !== null) urlParams.reviewerEmpid = reviewerEmpid;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  addCascade(formData): Observable<any> {
    const method: string = "POST";
    const func: string = "addCascade";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  cascadeHistory(formData): Observable<any> {
    const method: string = "POST";
    const func: string = "cascadeHistory";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  addEmpCascade(formData): Observable<any> {
    const method: string = "POST";
    const func: string = "addEmpCascade";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  getEmpCascade(formData): Observable<any> {
    const method: string = "POST";
    const func: string = "getEmpCascade";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public showButton(requestNo: string, empId: string, periodCode: string, formNo: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'showButton';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;
    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;
    if (typeof periodCode !== 'undefined' && periodCode !== null) urlParams.periodCode = periodCode;
    if (typeof formNo !== 'undefined' && formNo !== null) urlParams.formNo = formNo;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, null, 60000);
  }

  public performancePlanRequest(requestNo: string): Observable<any> {
    console.log('performancePlanRequest')
    const method: string = 'GET';
    const func: string = 'performancePlanRequest';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }
  
  public scoreType(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'scoreType';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/performance-planning.api.ts